export default __webpack_public_path__ + "static/media/check-in-daily-ico.7a3f8d0e.svg";